export default function NoPage() {
    return (<h1>404</h1>);
}